import axios from "axios";

const TOKEN_KEY = "api_access_token";
const TOKEN_URL = process.env.REACT_APP_API_BASE_URL_ANN_WEB_DEV + "/v1/token";

let isRefreshing = false;
let requestQueue = [];

const processQueue = (error, token = null) => {
  requestQueue.forEach(p => {
    if (error) p.reject(error);
    else p.resolve(token);
  });
  requestQueue = [];
};

export const tokenService = {
  getToken: () => localStorage.getItem(TOKEN_KEY),

  setToken: (token) => {
    localStorage.setItem(TOKEN_KEY, token);
  },

  
  fetchNewToken: async (userUuid, tenantUuid) => {
    const { data } = await axios.post(TOKEN_URL, { 
      user_uuid: userUuid,
      tenant_uuid: tenantUuid 
    });
    const newToken = data.body.token;
    tokenService.setToken(newToken);
    return newToken;
  },

 
  refreshToken: async (userUuid, tenantUuid) => {
    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        requestQueue.push({ resolve, reject });
      });
    }

    isRefreshing = true;
    try {
      const token = await tokenService.fetchNewToken(userUuid, tenantUuid);
      processQueue(null, token);
      return token;
    } catch (err) {
      processQueue(err, null);
      throw err;
    } finally {
      isRefreshing = false;
    }
  },
};
